<script setup lang="ts">
/**
 * RightPanel — Stats panel with full stat components
 * Shows StatsPanel when a fit is loaded, empty state otherwise.
 * SkillsPanel at the bottom (collapsible).
 */
import { useFitStore } from '../../stores/fitStore';
import StatsPanel from '../stats/StatsPanel.vue';
import SkillsPanel from '../skills/SkillsPanel.vue';

const store = useFitStore();

function handleSetAllSkills(level: number): void {
  store.setAllSkills(level);
}
</script>

<template>
  <aside class="right-panel">
    <div class="panel-header">Stats</div>

    <template v-if="store.activeStats">
      <StatsPanel :stats="store.activeStats" />
      <SkillsPanel @set-all-skills="handleSetAllSkills" />
    </template>

    <template v-else>
      <div class="empty-state">
        <span>Select a ship to see stats</span>
      </div>
    </template>
  </aside>
</template>

<style scoped>
.right-panel {
  display: flex;
  flex-direction: column;
  width: 360px;
  min-width: 0;
  max-width: 100%;
  background:
    linear-gradient(180deg, rgba(17, 24, 32, 0.96), rgba(8, 11, 16, 0.98)),
    var(--bg-panel);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  box-shadow: var(--glow-panel);
  overflow: hidden;
}

.panel-header {
  padding: 11px 14px 10px;
  color: var(--accent-blue);
  border-bottom: 1px solid var(--border-color);
  background:
    linear-gradient(90deg, rgba(0, 212, 255, 0.08), transparent 58%),
    rgba(0, 0, 0, 0.12);
  flex-shrink: 0;
  font-family: var(--font-mono);
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  color: var(--text-secondary);
  font-family: var(--font-mono);
  font-size: 0.72rem;
  letter-spacing: 0.08em;
  padding: 24px;
  text-align: center;
  text-transform: uppercase;
}

@media (max-width: 900px) {
  .right-panel {
    width: 100%;
  }

  .panel-header {
    padding: 8px 10px;
    font-size: 0.68rem;
  }
}
</style>
